import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import FlexCenter from "noood/comp/ui/containers/flex-boxes/FlexCenter";
import Spacer from "noood/comp/ui/spacer/Spacer";
import SpinnerApple from "noood/comp/ui/spinner/Spinner.Apple";
import NoRecords from "noood/comp/data/NoRecords";
export default function LoadableListContainer(props) {
  useEffect(function () {}, [props.list]);
  if (props.list === void 0 || props.list === null) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
      mtop: 20
    }), props.skeleton ? /*#__PURE__*/React.createElement(React.Fragment, null, Array(props.count).fill(0).map(function (skeleton, idx) {
      return /*#__PURE__*/React.createElement("div", {
        key: "skeleton-".concat(idx)
      }, props.skeleton);
    })) : /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React.createElement(SpinnerApple, {
      size: 25,
      color: "var(--text-color)"
    })));
  }
  if (props.list) {
    var _props$list, _props$children;
    return ((_props$list = props.list) === null || _props$list === void 0 ? void 0 : _props$list.length) > 0 ? (_props$children = props.children) !== null && _props$children !== void 0 ? _props$children : null : /*#__PURE__*/React.createElement(FlexCenter, null, /*#__PURE__*/React.createElement(NoRecords, {
      message: props.noRecordsFoundMsg,
      caption: props.noRecordsFoundCaption,
      space: props.space
    }));
  }
}
LoadableListContainer.propTypes = {
  list: PropTypes.array,
  noRecordsFoundMsg: PropTypes.string,
  noRecordsFoundCaption: PropTypes.string,
  skeleton: PropTypes.element,
  count: PropTypes.number
};
LoadableListContainer.defaultProps = {
  count: 10
};